import { Button, notification } from "antd";
import { useState } from "react";
import { Col } from "react-bootstrap";
import logo from "../../../assets/images/teenzaniLogo.png";
import herryUp from "../../../assets/images/hurryUp.png";
import BookingFormModal from "./bookingForm";
import TicketModal from "../../../admin/Tickets/ticketModal";
import { POST } from "../../../utils/apiRequest";
import { API } from "../../../config/Api";
import { KEYS } from "../../../config/keys";
import "../styles.scss";
const Fade = require("react-reveal/Fade");

// Add type for booking response
// type BookingResponse = { ... };

function SummaryScreen(props: any) {
  const { selectedOffers = [], onClose, onClear } = props;
  const [bookingFormModalOpen, setBookingFormModalOpen] = useState(false);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [ticketNo, setTicketNo] = useState<string | null>(null);
  const grandTotal = selectedOffers.reduce(
    (sum: number, offer: any) => sum + Number(offer.price) * offer.count,
    0
  );

  // Razorpay integration for offers-based booking
  const handleBooking = (bookingInfo: any) => {
    const RAZORPAY_KEY = KEYS.RAZORPAY_KEY;
    var options = {
      key: RAZORPAY_KEY,
      key_secret: KEYS.RAZORPAY_PRIVATE,
      amount: Number(grandTotal) * 100,
      currency: "INR",
      name: "Teenzania",
      description: "Ticket Payment",
      handler: function (response: any) {
        createBooking(bookingInfo, response.razorpay_payment_id);
      },
      theme: { color: "#08493e" },
      notes: {
        address: "Razorpay Corporate office",
      },
    };
    var pay = new window.Razorpay(options);
    pay.open();
  };

  // Create booking in backend after payment
  const createBooking = async (bookingInfo: any, paymentId: string) => {
    try {
      const response = await POST(API.BOOKING_ADD, { ...bookingInfo, paymentId }) as any;
      if (response?.status) {
        setBookingFormModalOpen(false);
        setTicketNo(response?.data?.ticketNo ?? null);
        setTicketModalOpen(true);
        if (onClear) onClear();
        notification.success({ message: "Successfully Booked" });
      } else {
        notification.error({ message: "Failed to Book" });
      }
    } catch (error) {
      notification.error({ message: "Error", description: "Something went wrong" });
    }
  };

  return (
    <div className="summaryBBox">
      <div className="d-flex justify-content-center">
        <img src={logo} alt="teenzaniaLogo" height={60} />
      </div>
      <div className="summaryHead">Booking Summary</div>
      <div style={{ borderBottom: "1px solid #cacccf" }}></div>
      <br />
      <div className="summaryBBox2">
        {selectedOffers.length === 0 ? (
          <div className="d-flex  align-items-center flex-column">
            <Fade top>
              <img src={herryUp} alt="herryup" width={"100px"} />
            </Fade>
            <div className="text-center">Please select an offer</div>
            <Col className=" my-2 d-block d-md-none">
              <Button type="primary" onClick={onClose}>
                Select Offers
              </Button>
            </Col>
          </div>
        ) : (
          selectedOffers.map((offer: any, index: any) => (
            <div key={offer.id} className="my-3">
              <div className="summaryKey">
                {index + 1}. {offer.title}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="summaryValue ms-2">
                  <div>Count: {offer.count}</div>
                  <div>Price: {offer.price}</div>
                </div>
                <div className="summaryValue ms-2">
                  <div>Total: {Number(offer.price) * offer.count}</div>
                </div>
              </div>
              <div
                className="summaryKey my-1 d-flex justify-content-end"
                style={{ fontSize: 15 }}
              >
                Total: {Number(offer.price) * offer.count} /-
              </div>
              {selectedOffers.length > 1 && (
                <div
                  style={{
                    borderBottom:
                      index === selectedOffers.length - 1
                        ? ""
                        : "1px solid #cacccf",
                  }}
                />
              )}
            </div>
          ))
        )}
      </div>
      <div className="d-flex my-3 justify-content-between">
        <Button
          onClick={onClear}
          style={{ border: "none" }}
          disabled={selectedOffers.length === 0}
        >
          Clear
        </Button>
        <Button
          type="primary"
          disabled={selectedOffers.length === 0}
          onClick={() => setBookingFormModalOpen(true)}
        >
          Pay ₹ {grandTotal}/-
        </Button>
      </div>
      <div>
        <div style={{ borderBottom: "1px solid #cacccf" }}></div>
        <div className="SummaryCard_Footer">
          <div>*Working Hours: 10:00AM to 12:00 AM</div>
          <div>*We are open on all Public Holidays</div>
          <div>*Terms and Conditions Apply</div>
        </div>
      </div>
      {/* Booking Form Modal */}
      {bookingFormModalOpen && (
        <BookingFormModal
          open={bookingFormModalOpen}
          close={() => setBookingFormModalOpen(false)}
          offers={selectedOffers}
          grandTotal={grandTotal}
          makePayment={handleBooking}
        />
      )}
      {/* Ticket Modal */}
      {ticketModalOpen && ticketNo && (
        <TicketModal
          view={ticketModalOpen}
          onClose={() => setTicketModalOpen(false)}
          ticketNo={ticketNo}
          booking={true}
        />
      )}
    </div>
  );
}

export default SummaryScreen;
